/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { useOfficeComponentContext } from '@office-start/component-context-service';
import { isQueryExecuted, useQuery, } from '@office-start/data-fetching';
import { useIdentity } from '@office-start/identity-service';
import { OfficeHomeContext } from '@office-start/office-home-context';
import { mark as markPerformance } from '@office-start/performance-service';
import { useContext, useEffect, useMemo } from 'react';
import { executeFeatureSettingsDataFlow } from '../executeFeatureSettingsDataFlow';
import { setFeatureSettings } from '../fetchFeatureSettings';
var isPerfLogged = false;
var hasSetFeatureSettings = false;
export function useFeatureSettings() {
    var _a;
    var featureSettings = useContext(OfficeHomeContext).featureSettings;
    var componentContext = useOfficeComponentContext().data;
    var identity = useIdentity().data;
    var query = ['FeatureSettings'];
    useEffect(function () {
        if (featureSettings && !hasSetFeatureSettings) {
            setFeatureSettings(featureSettings);
            hasSetFeatureSettings = true;
        }
    }, [featureSettings]);
    var memoizedFeatureSettings = useMemo(function () {
        if (featureSettings) {
            return {
                data: { fromPersistence: false, result: featureSettings },
            };
        }
        else {
            return {
                data: null,
            };
        }
    }, [featureSettings]);
    // This useQuery will used as a fallback when featureSettings (from context, fetch from DOM) is not available
    var queryResult = useQuery(query, function () { return executeFeatureSettingsDataFlow(identity, componentContext); }, {
        staleTime: Infinity,
        cacheTime: Infinity,
        enabled: componentContext && identity && !featureSettings,
    });
    var memoizedQueryResult = useMemo(function () { return queryResult; }, [queryResult]);
    var result = ((_a = memoizedFeatureSettings.data) === null || _a === void 0 ? void 0 : _a.result)
        ? memoizedFeatureSettings
        : memoizedQueryResult;
    var memoizedResult = useMemo(function () { return result; }, [result]);
    if (!isPerfLogged && isQueryExecuted(memoizedResult)) {
        markPerformance("UseFeatureSettingsReturn" /* KnownPerformanceMarks.UseFeatureSettingsReturn */, "React_Render_Ohome_Start" /* KnownPerformanceMarks.ReactRenderOhomeStart */);
        isPerfLogged = true;
    }
    return memoizedResult;
}
//# sourceMappingURL=useFeatureSettings.js.map